import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Modal } from "react-bootstrap";
import axios from "axios";

import "../assets/css/modal.css";

import { apiUrl } from "../config";

const ReportModal = (props) => {
  const [questionReportComplete, setQuestionReportComplete] = useState(false);
  const closeModal = () => {      
      props.setToggleReportModal(false)
      setQuestionType("資料問題")    
      setQuestionDescription("")
      setQuestionReportNotCompleteAlert(null)
      setQuestionReportComplete(false)
  };

  const location = useLocation();
  const [pageText, setPageText] = useState("");
  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setPageText("首頁");
        break;
      case "/guide":
        setPageText("說明頁");
        break;
      case "/collection":
        setPageText("檢索結果頁");
        break;
      case "/collection/film":
        setPageText("藏品詳目頁---類別：膠片類");
        break;
      case "/collection/paper":
        setPageText("藏品詳目頁---類別：海報類");
        break;
      case "/collection/item":
        setPageText("藏品詳目頁---類別：器物類");
        break;
      case "/collection/rf":
        setPageText("藏品詳目頁---類別：數位修復影片");
        break;
      case "/collection/df":
        setPageText("藏品詳目頁---類別：新聞片");
        break;
      default:
        setPageText("");
        break;
    }
  }, [location.pathname]);

  const clickImage = (dataImage) => {
    let html = "<img src='" + dataImage + "'/>";
    let newTab = window.open();
    newTab.document.write(html);
    newTab.focus();
  };

  const [questionType, setQuestionType] = useState("資料問題");
  const toggleQuestionType = (id) => {
    if (questionType !== id) {
      setQuestionType(id);
    }
  };

  const [hoverType, setHoverType] = useState("none");
  const hoverQuestionType = (mouse) => {
    if (mouse === "out") {
      setHoverType("none");
    } else {
      setHoverType(mouse);
    }
  };

  const getQuestionTypeExplain = () => {
    let type = hoverType !== "none" ? hoverType : questionType;
    if (type === "資料問題") {
      return "如果您的問題是有關資料錯誤，如錯、漏、缺字，又或是名稱錯誤等等。";
    } else if (type === "功能問題") {
      return "如果您的問題有關按鈕沒反應，查詢結果錯誤，等待時間過長等等";
    } else if (type === "其他問題") {
      return "如果您的問題非上述2者，又或是有寶貴建議惠予，請選此。";
    }
  };

  const [questionDescription, setQuestionDescription] = useState("");
  const changeDescription = (event) => {
    if (questionDescription !== event.target.value) {
      setQuestionDescription(event.target.value);
    }
  };
  
  const [loading, setLoading] = useState(false);
  const [questionReportNotCompleteAlert, setQuestionReportNotCompleteAlert] = useState(false);
  const checkQuestionReport = () => {
    if (questionDescription && questionDescription !== "") {
      setLoading(true)
      sendQuestinoReport();
    } else {
      if (!questionReportNotCompleteAlert) {
        setQuestionReportNotCompleteAlert(true);
      }
    }
  };

  // 發送HTTP請求獲取數據
  const sendQuestinoReport = async () => {
    try {
      await axios
        .post(apiUrl + "/problemreport", {
            imagePage: pageText,
            image: props.captureImage,
            problemType: questionType,
            problemDesc: questionDescription
        })
        .then((res) => {
          if (res.status === 200) {
            setQuestionReportComplete(true);
            props.setCaptureImage(null);
            setQuestionDescription(null);
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Modal style={{ zIndex: 6000, display: "flex", alignItems: "center", justifyContent: "center", overflow: "scroll" }}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      show={props.toggleReportModal}
      onHide={()=>closeModal()}
    >
      <div style={{ backgroundColor: "white", fontSize: "25px", padding: "20px", border: "1px solid #000000" }}>
        {questionReportComplete ? (
          <div>
            <h2 id="transition-modal-title">問題回報單</h2>
            <div style={{ fontSize: "15px" }}>您的問題我們已收到，感謝您。</div>
          </div>
        ) : (
          <div>
            <h2 id="transition-modal-title">問題回報單</h2>
            <div style={{ fontSize: "15px" }}>請您填寫下列資訊，幫助我們找出問題</div>
            <div>
              <div style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bolder" }}>
                1.截圖頁面
              </div>
              <div style={{ padding: "5px" }}>
                <div style={{ fontSize: "15px" }}>{pageText}</div>
              </div>
              <div style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bolder" }}>
                2.截圖
              </div>
              <div style={{ margin: "auto" }}>
                <div style={{ display: "inline-flex", border: "1px solid black", height: "auto" }}>
                  <img alt="captureImg" src={props.captureImage} style={{ cursor: "pointer", width: "100%", height: "auto" }} onClick={() => clickImage(props.captureImage)}></img>
                </div>
              </div>
              <div style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bolder" }}>
                3.問題類型
              </div>
              <div style={{ display: "flex" }}>
                <div className={ questionType === "資料問題" ? "questionTypeStyleSelected" : "questionTypeStyle" }
                  onMouseEnter={()=>hoverQuestionType("資料問題")} onMouseLeave={()=>hoverQuestionType("out")} onClick={()=>toggleQuestionType("資料問題")}>
                  資料問題
                </div>
                <div className={ questionType === "功能問題" ? "questionTypeStyleSelected" : "questionTypeStyle" }
                  onMouseEnter={()=>hoverQuestionType("功能問題")} onMouseLeave={()=>hoverQuestionType("out")} onClick={()=>toggleQuestionType("功能問題")}>
                  功能問題
                </div>
                <div className={ questionType === "其他問題" ? "questionTypeStyleSelected" : "questionTypeStyle" }
                  onMouseEnter={()=>hoverQuestionType("其他問題")} onMouseLeave={()=>hoverQuestionType("out")} onClick={()=>toggleQuestionType("其他問題")}>
                  其他問題
                </div>
              </div>
              <div style={{ fontSize: "12px", color: "gray", margin: "15px 20px 10px 10px" }}>{getQuestionTypeExplain()}</div>
              <div style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bolder", color: questionReportNotCompleteAlert ? "red" : null }}>
                4.問題描述 (必填)
              </div>
              <div>
                <textarea style={{ fontSize: "15px", width: "80%", height: "100px", resize: "none", 
                    border: questionReportNotCompleteAlert ? "1px solid red" : "1px solid gray" }}
                    type="text" value={questionDescription} onChange={changeDescription} />
              </div>
            </div>
            <div style={{ width: "50%", margin: "auto" }}>
              <div style={{ display: "flex", marginTop: "50px", justifyContent: "center" }}>
                <div className={`modalbuttom ${loading ? 'disabled' : ''}`} onClick={checkQuestionReport}>回報問題</div>
                <div className={"modalbuttom"} onClick={()=>closeModal()}>取消</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ReportModal;
